
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 新增角色
export function insertRole(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role',
    method: 'POST',
    data: parameter
  })
}
// 修改角色
export function updateRole(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role',
    method: 'PUT',
    data: parameter
  })
}
// 校验角色code唯一性
export function checkRoleCode(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/check',
    method: 'GET',
    params: parameter
  })
}
// 删除角色
export function deleteRole(id) {
  return axios({
    url: sysInfo.apiRemote + `/role/${id}`,
    method: 'DELETE'
  })
}
// 获取角色列表
export function getRoleList(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role',
    method: 'GET',
    params: parameter
  })
}
// 获取角色用户列表
export function getUserList(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/user',
    method: 'GET',
    params: parameter
  })
}
// 获取角色可添加分组列表
export function getGroupChooseList(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/group/choose',
    method: 'GET',
    params: parameter
  })
}
// 获取角色可添加人员列表
export function getUserChooseList(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/user/choose',
    method: 'GET',
    params: parameter
  })
}
// 角色添加分组
export function insertRoleGroup(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/group',
    method: 'POST',
    data: parameter
  })
}
// 角色添加人员
export function insertRoleUser(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/user',
    method: 'POST',
    data: parameter
  })
}
// 角色移除人员或分组
export function deleteRoleGroupUser(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/user',
    method: 'DELETE',
    data: parameter
  })
}
// 获取角色权限
export function getRolePermissions(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/menu',
    method: 'GET',
    params: parameter
  })
}
// 保存角色权限
export function saveRolePermissions(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/menu',
    method: 'PUT',
    data: parameter
  })
}
// 拖拽角色
export function dragRole(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/drag',
    method: 'PUT',
    data: parameter
  })
}
// 设置归口部门权限分配
export function setDeptPermission(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/dept/permission',
    method: 'POST',
    data: parameter
  })
}
// 获取角色部门权限
export function getDeptPermission(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/dept/permission',
    method: 'GET',
    params: parameter
  })
}
// 设置角色公司权限
export function setRoleCompanyPermission (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/company/permission',
    method: 'POST',
    data: parameter
  })
}
// 获取角色公司权限
export function getRoleCompanyPermission (parameter) {
  return axios({
    // url: '/data/roleCompanyPermission.json',
    url: sysInfo.apiRemote + '/role/company/permission',
    method: 'GET',
    params: parameter
  })
}
// 设置使用部门
export function setRoleUseDeptPermission (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/usedept/permission',
    method: 'POST',
    data: parameter
  })
}
// 获取角色公司权限
export function getRoleUseDeptPermission (parameter) {
  return axios({
    // url: '/data/roleUseDeptPermission.json',
    url: sysInfo.apiRemote + '/role/usedept/permission',
    method: 'GET',
    params: parameter
  })
}
// 归口部门集合
export function getRelevants (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevants',
    method: 'GET',
    params: parameter
  })
}

// 获取资产类型权限列表
export function getAssetTypePermission(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/assetType/permission',
    method: 'GET',
    params: parameter
  })
}
// 新增资产类型角色权限
export function setAssetTypePermission(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/assetType/permission',
    method: 'POST',
    data: parameter
  })
}
// 获取设备类型权限列表
export function getEquipmentTypePermission(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/equipmentType/permission',
    method: 'GET',
    params: parameter
  })
}
// 新增设备类型角色权限
export function setEquipmentTypePermission(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/equipmentType/permission',
    method: 'POST',
    data: parameter
  })
}
